export const InputButton = {
  Fire: 1,
  Reload: 2,
  Jump: 4,
  Melee: 8,
} as const;
